export type NotificationCardType = 'feature' | 'info' | 'warning';

export class NotificationCard {
  id: null | string = null;
  title = '';
  description = '';
  imageUrl = '';
  cardType: NotificationCardType = 'feature';
  linkText = '';
  linkUrl = '';

  constructor(
    id: null | string,
    title: string,
    description: string,
    options?: {
      color?: string;
      imageUrl?: string;
      linkText?: string;
      url?: string;
    }
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    if (options) {
      if (typeof options.color === 'string') {
        switch (options.color) {
          case 'blue':
          case 'info':
            this.cardType = 'info';
            break;
          case 'feature':
          case 'green':
            this.cardType = 'feature';
            break;
          case 'red':
          case 'warning':
            this.cardType = 'warning';
            break;
          // no default
        }
      }

      this.imageUrl =
        typeof options.imageUrl === 'string' ? options.imageUrl : '';
      this.linkText =
        typeof options.linkText === 'string' ? options.linkText : '';
      this.linkUrl = typeof options.url === 'string' ? options.url : '';
    }
  }
}
